export default `float de( vec3 p){
    vec2 t = vec2(1.0,0.2); 
    vec2 q = vec2(length2(p.xz)-t.x, p.y);
    return length8(q) - t.y;
  }`